import React from 'react';
import { useTranslation } from 'react-i18next';
import { YStack } from 'tamagui';

import { WidgetCard, SkeletonBox } from '../../../components/common';

export const WeatherUVIndexCardSkeleton = () => {
  const { t } = useTranslation();

  return (
    <WidgetCard
      title={t('weather.uvIndex')}
      isDraggable={false}
      dragHandleProps={null}
      error={false}
      gap="$3.5">
      <YStack alignItems="center" gap="$3.5" justifyContent="space-between" height="100%" flex={1}>
        <YStack paddingVertical="$5" gap="10px" alignItems="center">
          <SkeletonBox width={120} height={120} borderRadius="$6" />
          <SkeletonBox height={60} width={150} />
        </YStack>
        <SkeletonBox height={28} width={200} />
      </YStack>
    </WidgetCard>
  );
};
